/** Path-based product landings (always available at these URLs on any host). */
export const LANDING_PATHS = {
  main: "/",
  mainPreview: "/lp/main-landing",
  partner: "/lp/partner-landing",
  roofing: "/lp/roofing-landing",
  realEstate: "/lp/real-estate-landing",
  interceptProtocol: "/lp/intercept-protocol",
};

/**
 * Root `/` landing is chosen by hostname (see lib/siteHosts.js):
 * - fractolabs.com, www, localhost → main landing
 * - partner / roofing / inbnd.fractolabs.com → matching product landing
 * - ai.fractolabs.com → redirect to /login
 * - other hosts → neutral stub landing
 */
export const appLoginPath = (returnPath = "/dashboard") => {
  const encoded = encodeURIComponent(returnPath);
  return `/login?returnTo=${encoded}`;
};
